export default __webpack_public_path__ + "static/media/add-circle-fill.6d54887d.svg";